import uuidV4 from 'uuid/v4';
import {Answer, PageType} from '@livongo/protobuf-grpc-external-education';

const PageTypes = {
    ...PageType.Values,
    ACKNOWLEDGE: -1,
};

const FieldTypes = {
    BODY: 'BODY',
    TITLE: 'TITLE',
    TIP_TYPE: 'TIP_TYPE',
    QUESTION: 'QUESTION',
    HERO_IMAGE: 'HERO_IMAGE',
    DESCRIPTION: 'DESCRIPTION',
    OTHER_ANSWER: 'OTHER_ANSWER',
    INCLUDE_OTHER: 'INCLUDE_OTHER',
    ACKNOWLEDGEMENT: 'ACKNOWLEDGEMENT',
    OTHER_PLACEHOLDER: 'OTHER_PLACEHOLDER',
};

function normalizePageData(pages, t) {
    const {INCLUDE_OTHER, OTHER_ANSWER} = FieldTypes;
    const allPages = [];
    let newPageNumber = 0;

    pages.forEach(page => {
        newPageNumber++;

        page.setPageNumber(newPageNumber);
        page.showInTOC = true;

        allPages.push(page);

        if (page.getPageType() === PageTypes.QUESTION_PAGE) {
            newPageNumber++;

            // add user input option to answers if applicable
            const textFields = page.getTextFieldsMap();
            const hasUserInput = textFields.has(INCLUDE_OTHER)
                ? JSON.parse(
                      textFields.get(INCLUDE_OTHER).getTextValue().toLowerCase()
                  )
                : false;

            if (hasUserInput) {
                const inputAnswer = new Answer();
                const inputLabel = textFields.get(OTHER_ANSWER);
                const answerText = inputLabel
                    ? inputLabel.getTextValue()
                    : t('other');

                inputAnswer.setAnswerCmsId('other');
                inputAnswer.setAnswerText(answerText);
                inputAnswer.setIsCorrect(false);
                inputAnswer.hasInput = true;

                page.getAnswersList().push(inputAnswer);
            }

            // add acknowledge page for the given question page
            const newPage = page.cloneMessage();

            newPage.setPageId(uuidV4());
            newPage.setPageNumber(newPageNumber);
            newPage.setPageType(PageTypes.ACKNOWLEDGE);
            newPage.showInTOC = false;

            allPages.push(newPage);
        }
    });

    return allPages;
}

function getDomainName() {
    return window.location.hostname?.split('.')?.splice(-2)?.join('.');
}

export {PageTypes, FieldTypes, normalizePageData, getDomainName};
